module.exports = __webpack_public_path__ + "img/qr_04.280fea54.jpg";